 const ViewTeamAttendanceStyles = {
    attendanceWrapper: {
        padding: "20px 20px",
      },
    LeaveBoxPart: {
      display: "flex",
      gap: "30px",
    },
    innerPopOver: {
      padding: "5px",
      display: "flex",
      width: "100%",
      height: "100%",
      flexDirection: "column",
      justifyContent: "start",
      alignItems: "start",
      "& button": {
        width: "fit-content",
        "&:hover": {
          background: "none",
        },
      },
    },
    verticalDotButton: {
      "& button": {
        "&:hover": {
          background: "none",
        },
      },
    },
 }

 export default ViewTeamAttendanceStyles;